import React from 'react';

const Tags = ({
  tagsClass,
  tagsTitle,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "tags ".concat(tagsClass)
}, /*#__PURE__*/React.createElement("h3", null, tagsTitle), /*#__PURE__*/React.createElement("div", {
  className: "tags__inner"
}, children));

Tags.displayName = 'Tags';
Tags.defaultProps = {
  tagsClass: '',
  tagsTitle: 'Tags'
};
export default Tags;